import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from 'models/field.interface';
import { UtilityService } from 'services';

@Component({
  templateUrl: './input.component.html'
})
export class InputComponent {

  field: FieldConfig;
  group: FormGroup;

  constructor(private util: UtilityService) { }

  getValidationMessage(val) {
    if (val === 'required') {
      return 'This field is required.';
    }
    return 'Invalid';
  }
  isNativeType(type: string) {
    if (type && (type === 'text' || type === 'number' || type === 'password')) {
      return true;
    }
    return false;
  }
  isRequired() {
    return this.util.isRequired(this.group.get(this.field.name));
  }
}
